const RANK_KEYS = [
    (identity) => (identity.loginCapable ? 1 : 0),
    (identity) => (identity.removed ? 0 : 1),
    (identity) => (identity.lastActivityAt ? Date.parse(identity.lastActivityAt) : 0),
    (identity) => identity.sessionCount,
];
/** The identity a merge keeps: one that can log in, then one with a live account, then the most recent activity, then more sessions. A full tie keeps the first. */
export function rankMergeTarget(first, second) {
    for (const key of RANK_KEYS) {
        const diff = key(first) - key(second);
        if (diff !== 0)
            return diff > 0 ? first.userId : second.userId;
    }
    return first.userId;
}
//# sourceMappingURL=merge.js.map